export default __webpack_public_path__ + "static/media/login.c8d61989.svg";